import { doGet } from "../api/baseAPI";
import { GROLOG_ORDER_URL } from "../constant/apiConstant";

export const orderGetList = async (token, api_contract, params ) => {
  const url = `${GROLOG_ORDER_URL}/${api_contract}`;
  let result = { data: undefined, ok: false };

  try {
    const response = await doGet(token, url, params);
    if (response) {
      result.ok = true;
      result.data = response.data.payload.data;
    }
  } catch (error) {
    return error
  }
  return result;
}

export const orderInitiate = async (token, api_contract, params ) => {
  const url = `${GROLOG_ORDER_URL}/${api_contract}/initiate`;
  let result = { data: undefined, ok: false };

  try {
    const response = await doGet(token, url, params);
    if (response) {
      result.ok = true;
      result.data = response.data.payload.data;
    }
  } catch (error) {
    return error
  }
  return result;
}
